import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.purchaseOrder.general,
        label: 'General',
        permission: PERMISSIONS.purchaseOrders.tabs.general.read,
        id: 'PRO-1',
      },
      {
        path: ADMIN_ROUTES.purchaseOrder.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.purchaseOrders.tabs.task.read,
        id: 'PRO-2',
      },
      {
        path: ADMIN_ROUTES.purchaseOrder.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.purchaseOrders.tabs.communicationHub.read,
        id: 'PRO-3',
      },
      {
        path: ADMIN_ROUTES.purchaseOrder.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.purchaseOrders.tabs.attachment.read,
        id: 'PRO-4',
      },
      {
        path: ADMIN_ROUTES.purchaseOrder.logs,
        label: 'Logs',
        permission: PERMISSIONS.purchaseOrders.tabs.logs.read,
        id: 'PRO-5',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
